var map = {
	"./auth.js": 381,
	"./business.js": 382,
	"./lookup.js": 383,
	"./user.js": 384
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;


//////////////////
// WEBPACK FOOTER
// ./src/api/endpoints \.js$
// module id = 670
// module chunks = 8